import React from "react";
import { AppRouter } from "../shared/components/AppRouter";
import { routes } from "./routes";

export const HighlightsRoutes = () => <AppRouter routes={routes} />;
